import { DocumentTemplateEditItem, IDocumentTemplateEditItem } from "./documentTemplateEditItem";

export interface IDocumentTemplateEdit {
    item: IDocumentTemplateEditItem;
}

export class DocumentTemplateEdit implements IDocumentTemplateEdit {
    item: DocumentTemplateEditItem;

    constructor();
    constructor(obj: IDocumentTemplateEdit);
    constructor(obj?: any) {
        this.item = new DocumentTemplateEditItem(obj ? obj.item : null);
    }
}